import React, { useState, useEffect } from "react"
import { Box, FormControl, FormLabel, Select, Text } from "@chakra-ui/react"
import { useAppContext } from "../AppContext" // Adjust the import path as necessary
import { AccountService } from "../api" // Adjust the import path as necessary
import { TradeService } from "../api/trade"

export const WalletSelector: React.FC = () => {
  const { wallets, setWallets, setActiveWallet } = useAppContext()
  const [selectedWallet, setSelectedWallet] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  // Fetch public keys only once when the component mounts
  useEffect(() => {
    const fetchPublicKeys = async () => {
      try {
        const keys = await AccountService.getAllPublicKeys()
        setWallets(keys) // Update context state
        setLoading(false)
      } catch (err) {
        console.error("Error fetching public keys:", (err as Error).message)
        setError("Failed to fetch public keys.")
        setLoading(false)
      }
    }

    fetchPublicKeys()
  }, [setWallets])

  const handleWalletChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const walletId = event.target.value
    const wallet = wallets?.[walletId] // Access wallet by ID
    if (wallet) {
      await TradeService.prepareAccount(walletId)
      setSelectedWallet(wallet)
      setActiveWallet({ ...wallet, identifier: walletId }) // Set the active wallet in context
    }
  }

  return (
    <Box borderWidth="1px" borderRadius="lg" padding="6" boxShadow="lg" backgroundColor="white" mt="2" width="100%">
      {loading ? (
        <Text>Loading wallets...</Text>
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        <FormControl>
          <FormLabel htmlFor="walletSelect">Wallet</FormLabel>
          <Select id="walletSelect" onChange={handleWalletChange} placeholder="Select a wallet">
            {wallets &&
              Object.entries(wallets).map(([identifier, { balance }]) => (
                <option key={identifier} value={identifier}>
                  {identifier} - SOL: {balance}
                </option>
              ))}
          </Select>
        </FormControl>
      )}
    </Box>
  )
}
